import { createResourceUrl } from "../../../utils/resourceUtils";
import scriptLoader from "../../../utils/scriptLoader";
import { initializeTransmitParams } from "./transmitParams";
const initializationCheckTimes = 20;
const intervalInMS = 1000;
function initializedPromise(callback, errorString, intervalInMs, times) {
    let count = 0;
    function checkIfLoaded(resolve, reject) {
        if (count === times) {
            reject(errorString);
            return;
        }
        if (callback()) {
            resolve();
        }
        else {
            count += 1;
            setTimeout(() => checkIfLoaded(resolve, reject), intervalInMs);
        }
    }
    return new Promise((resolve, reject) => {
        checkIfLoaded(resolve, reject);
    });
}
function isBlackboxInitialized() {
    return window.IGLOO && typeof window.IGLOO.getBlackbox === "function";
}
export function loadTransmitDependencies(transmitStartResponse, appConfig, successCallback, failureCallback) {
    const scriptLoads = [];
    if (!isBlackboxInitialized()) {
        scriptLoads.push(scriptLoader(createResourceUrl(appConfig.webUrl, 'io-loader.js'), false, false));
        scriptLoads.push(initializedPromise(isBlackboxInitialized, "Blackbox initialization error", intervalInMS, initializationCheckTimes));
    }
    Promise.all(scriptLoads)
        .then(() => initializeTransmitParams(transmitStartResponse, appConfig))
        .then(successCallback)
        .catch(failureCallback);
}
